<template>
	<div class="home" v-loading="loading">
		<swiper id="swiperBox" v-bind:options="swiperOption" ref="mySwiper">
			<swiper-slide class="swiper-slide slide-one">
			</swiper-slide>
			<swiper-slide class="swiper-slide slide-two">
				<div class="page">
					<h3>全系产品</h3>
					<p>Full range of products</p>
				</div>
				<ul class="case-item">
					<li>
						<img src="../assets/img/good1.jpg" alt="index" />
					</li>
					<li>
						<img src="../assets/img/good2.jpg" alt="index" />
					</li>
					<li>
						<img src="../assets/img/good3.jpg" alt="index" />
					</li>
					<li>
						<img src="../assets/img/good4.jpg" alt="index" />
					</li>
					<li>
						<img src="../assets/img/good5.jpg" alt="index" />
					</li>
					<li>
						<img src="../assets/img/good6.jpg" alt="index" />
					</li>
					<li>
						<img src="../assets/img/good7.jpg" alt="index" />
					</li>
					<li>
						<img src="../assets/img/good8.jpg" alt="index" />
					</li>
				</ul>
			</swiper-slide>
			<swiper-slide class="swiper-slide slide-three">
				<div class="page">
					<h3>最新资讯</h3>
					<p>Latest News</p>
				</div>
				<div class="news-content">
					<div class="news-content-item">
						<div style="order: 1">
							<div class="text-decoration">
								<img src="../assets/img/news-bg1.jpg" alt="" class="item-img" />
							</div>
						</div>
						<div style="order: 2">
							<el-divider>
								<i class="el-icon-apple"></i>
							</el-divider>
						</div>
						<div class="item-content" style="order: 3">
							<h3>隐酿散酒铺子，是一家融合了传统酿造智慧与现代生活哲学的散酒连锁品牌实体店。</h3>
							<p>我们潜心酿造四方美酒，无论是温婉细腻的江南小酌，还是豪迈奔放的异国佳酿，风格万千，任君品鉴。我们深信，真正的好酒，非浮华的外表所能及，因此，我们摒弃繁复包装，保留对纯粹酒香的渴望，为那些真正懂酒、爱酒的知音人，提供悠然自得的品鉴时光，便捷贴心的..
							</p>
							<span>2024-03-01</span>
						</div>
					</div>
					<div class="news-content-item">
						<div style="order: 3">
							<div class="text-decoration">
								<img src="../assets/img/news-bg2.jpg" alt="" class="item-img" />
							</div>
						</div>
						<div style="order: 2">
							<el-divider>
								<i class="el-icon-apple"></i>
							</el-divider>
						</div>
						<div class="item-content" style="order: 1">
							<h3>这是关于等待和发现的故事，一个关于耐心和智慧的故事，一个关于好酒和知音的故事。</h3>
							<p>在遥远的古代，有一位智者，他并非寻常渔夫，而是世代流传的姜太公。姜太公，一个以直钩垂钓于渭水之畔的传奇人物，他垂钓的并非鱼，而是等待一位能够赏识他才华的明君。八年时光，不为名利所动，不为世俗所扰，他的耐心与智慧，如同那静静流淌的河水，深邃而内敛..
							</p>
							<span>2023-12-31</span>
						</div>
					</div>
					<div class="news-content-item">
						<div style="order: 1">
							<div class="text-decoration">
								<img src="../assets/img/news-bg3.jpg" alt="" class="item-img" />
							</div>
						</div>
						<div style="order: 2">
							<el-divider>
								<i class="el-icon-apple"></i>
							</el-divider>
						</div>
						<div class="item-content" style="order: 3">
							<h3>一家充满故事与韵味的隐酿散酒铺子。没有华丽的招牌，却靠着醇厚的酒香吸引着邻里街坊。</h3>
							<p>这里的酒，每一款都是匠心独运的杰作。从清香四溢的小曲酒，到浓郁绵柔的大曲酒，口感丰富得如同一场味蕾的奇幻之旅。老板就像一位亲切的老友，耐心地为每一位顾客介绍不同酒的特色与风味，根据你的喜好给出最贴心的推荐。无论是家庭小聚时的温馨陪伴,还是老友重逢时..
							</p>
							<span>2023-05-01</span>
						</div>
					</div>
				</div>
			</swiper-slide>
		</swiper>
	</div>
</template>

<script>
	import {
		swiper,
		swiperSlide
	} from "vue-awesome-swiper";
	export default {
		name: "HelloWorld",
		components: {
			swiper,
			swiperSlide
		},
		data() {
			return {
				loading: false,

				swiperOption: {
					notNextTick: true, //notNextTick是一个组件自有属性，如果notNextTick设置为true，组件则不会通过NextTick来实例化swiper，也就意味着你可以在第一时间获取到swiper对象，假如你需要刚加载遍使用获取swiper对象来做什么事，那么这个属性一定要是true
					direction: "vertical", //水平方向移动
					grabCursor: true, //鼠标覆盖Swiper时指针会变成手掌形状，拖动时指针会变成抓手形状
					setWrapperSize: true, //Swiper使用flexbox布局(display: flex)，开启这个设定会在Wrapper上添加等于slides相加的宽或高，在对flexbox布局的支持不是很好的浏览器中可能需要用到。
					autoHeight: true, //自动高度。设置为true时，wrapper和container会随着当前slide的高度而发生变化
					slidesPerView: 1, //设置slider容器能够同时显示的slides数量(carousel模式)。可以设置为数字（可为小数，小数不可loop），或者 'auto'则自动根据slides的宽度来设定数量。loop模式下如果设置为'auto'还需要设置另外一个参数loopedSlides。
					mousewheel: true, //开启鼠标滚轮控制Swiper切换。可设置鼠标选项，默认值false
					mousewheelControl: true, //同上
					height: window.innerHeight - 60, // 高度设置，占满设备高度
					resistanceRatio: 0, //抵抗率。边缘抵抗力的大小比例。值越小抵抗越大越难将slide拖离边缘，0时完全无法拖离。本业务需要
					observeParents: true, //将observe应用于Swiper的父元素。当Swiper的父元素变化时，例如window.resize，Swiper更新

					// 如果自行设计了插件，那么插件的一些配置相关参数，也应该出现在这个对象中，如下debugger
					//debugger: true,

					// swiper的各种回调函数也可以出现在这个对象中，和swiper官方一样
					on: {
						//监听滑动切换事件，返回swiper对象
						// slideChange: () => {
						//   let swiper = this.$refs.mySwiper.swiper;
						//   //console.log(swiper.activeIndex); //滑动打印当前索引
						//   if (swiper.activeIndex === this.list.length - 1) {
						//     //到最后一个加载更多数据
						//     let newList = [];
						//     let listLength = this.list.length;
						//     for (let i = 0; i < 10; i++) {
						//       newList.push(listLength + i);
						//     }
						//     this.list = this.list.concat(newList);
						//   }
						// }
					}
				}
			};
		},
		created() {},
		// 如果你需要得到当前的swiper对象来做一些事情，你可以像下面这样定义一个方法属性来获取当前的swiper对象，同时notNextTick必须为true
		computed: {
			swiper() {
				return this.$refs.mySwiper.swiper;
			}
		},
		mounted() {}
	};
</script>

<style lang="scss" scoped>
	/* .el-header {
  position: absolute;
} */
	.swiper-slide {
		font-size: 24px;
		// text-align: center;
		// line-height: 100px;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-content: center;

		.page {
			text-align: center;
			height: 100px;
			overflow: hidden;

			h3,
			p {
				font-size: 40px;
				font-weight: 400;
				color: #fff;
			}
		}

		.slogan {
			text-align: center;
			font-size: 50px;
			color: #fff;
			padding: 30px 0;
		}
	}

	//经典案例
	.case-item {
		width: 1300px;
		height: 630px;
		overflow: hidden;
		margin: 0 auto;
		margin-top: 30px;
		display: flex;
		flex-wrap: wrap;
		justify-content: flex-start;
		gap: 30px;

		li {
			width: 300px;
			height: 300px;
			list-style: none;
			background-repeat: no-repeat;
			background-size: cover;
			background-position: center;
			background-origin: content-box;
			position: relative;
			overflow: hidden;

			&:hover {
				.case-item-hover {
					opacity: 1;
					transition: all 0.4s ease-in-out;
				}
			}
		}
	}

	//经典案例hover
	.case-item-hover {
		width: 100%;
		height: 100%;
		position: absolute;
		top: 0;
		left: 0;
		opacity: 0;
		overflow: hidden;
		background-color: rgba(225, 56, 52, 0.7);

		.hover-title {
			height: 50px;
			color: #fff;
			font-size: 18px;
			overflow: hidden;
			text-overflow: ellipsis;
			white-space: nowrap;
			font-weight: 400;
			margin-top: 20px;
		}

		.bottom {
			border-bottom: 1px solid #fff;
			width: 60px;
			margin: 0 auto;
		}

		.more {
			width: 90px;
			padding: 5px 5px;
			margin: 0 auto;
			margin-top: 100px;
			border: 2px solid #fff;

			span {
				color: #fff;
				font-size: 20px;
			}
		}
	}

	// .swiper-slide:nth-child(2n) {
	//   background: skyblue;
	// }
	// .swiper-slide:nth-child(2n-1) {
	//   background: seashell;
	// }
	.slide-one {
		background: url(../assets/img/home_top.jpg) no-repeat center;
		background-size: 100% 100%;
	}

	.slide-two {
		background: url(../assets/img/home_do.jpg) no-repeat center;
		background-size: cover;
	}

	.slide-three {
		background: url(../assets/img/home_anli.jpg) no-repeat center;
		background-size: cover;
	}

	//最新资讯
	.news-content {
		width: 1240px;
		margin: 0 auto;
		margin-top: 40px;
		display: flex;
		justify-content: center;

		&-item {
			width: 400px;
			display: flex;
			flex-direction: column;

			.item-img {
				width: 360px;
				height: 224px;
				background-repeat: no-repeat;
				background-size: cover;
				background-position: center;
				background-origin: content-box;
				margin: 0 auto;
			}

			.el-divider {
				background-color: #E94C19;
				height: 3px;

				.el-divider__text {
					width: 20px;
					height: 20px;
					border-radius: 50%;
					padding: 0px;
					color: #E94C19;
					background-color: #E94C19;
				}
			}

			.item-content {
				width: 360px;
				height: 230px;
				margin: 0 auto;

				//border: 1px solid paleturquoise;
				h3 {
					font-size: 22px;
					height: 30px;
					overflow: hidden;
					text-overflow: ellipsis;
					white-space: nowrap;
				}

				p {
					font-size: 15px;
					height: 80px;
					overflow: hidden;
					margin: 10px 0;
					text-overflow: ellipsis;
					display: -webkit-box;
					-webkit-line-clamp: 4;
					-webkit-box-orient: vertical;
					white-space: normal !important;
					word-wrap: break-word;
				}

				span {
					display: block;
					font-size: 14px;
					text-align: end;
				}

				h3,
				p,
				span {
					color: #fff;
				}
			}
		}
	}

	.order {
		order: -1;
	}

	.order-img {
		order: 1;
	}
</style>